const isEmptyV = (v) => {
  return v === 0 || v === '0' || v === '' || v === 'n/a';
};

export { isEmptyV };
